export default {
      id: "auto-red-usage",
      viewBox: "0 0 197 24",
      url: __webpack_public_path__ + "sprite.svg#auto-red-usage",
      toString: function () {
        return this.url;
      }
    }